import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    filtroPesquisar: {
        marginTop: theme.spacing(1),
    },
}))